var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"services-list"}},[_c('ul',_vm._l((_vm.servicesList),function(serv){return _c('li',{key:serv.id},[_vm._v("\n      "+_vm._s(_vm._f("uppercase")(serv.content))+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }